import React, { forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Building2, Users, Shield } from "lucide-react";
import { dateLocale } from "i18n";

const WorkspaceRow = forwardRef(({ workspace, isLast }, ref) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString(dateLocale("en-US"), {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div
      ref={ref}
      onClick={() => navigate(`/v2/${workspace.id}`)}
      className={`flex cursor-pointer items-center justify-between px-4 py-3 transition duration-150 hover:bg-[#FAFAFA] ${
        !isLast ? "border-b border-[#F3F4F6]" : ""
      }`}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#F3F4F6]">
          <Building2 size={18} className="text-[#6B7280]" />
        </div>
        <div>
          <p className="text-sm font-medium text-[#111827]">{workspace.name}</p>
        </div>
      </div>

      <div className="flex items-center gap-8">
        <div className="flex items-center gap-1.5 text-xs text-[#6B7280]">
          <Users size={12} />
          <span>
            {t("admin.superUser.workspaceRow.memberCount", {
              total: workspace.member_count ?? 0,
            })}
          </span>
        </div>
        <div className="flex items-center gap-1.5 text-xs text-[#6B7280]">
          <Shield size={12} />
          <span>
            {t("admin.superUser.workspaceRow.teamCount", {
              total: workspace.team_count ?? 0,
            })}
          </span>
        </div>
        <span className="w-24 text-right text-xs text-[#9CA3AF]">
          {formatDate(workspace.created_at)}
        </span>
      </div>
    </div>
  );
});

WorkspaceRow.displayName = "WorkspaceRow";

export default WorkspaceRow;
